// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
// import '../styles/Login.css';
// import logoImg from '/Users/omaretkaidek/Desktop/Work/cobra-loyalty-app/loyalty-points-app/src/logo.png';

// const LoginPage = () => {
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const navigate = useNavigate();

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setError('');
//     setLoading(true);

//     try {
//       const auth = getAuth();
//       await signInWithEmailAndPassword(auth, email, password);
//       // Successful login
//       navigate('/dashboard');
//     } catch (err) {
//       console.error('Login error:', err.message);
      
//       // Handle different error codes with user-friendly messages
//       switch (err.code) {
//         case 'auth/invalid-email':
//           setError('صيغة البريد الإلكتروني غير صالحة');
//           break;
//         case 'auth/user-disabled':
//           setError('تم تعطيل هذا الحساب');
//           break;
//         case 'auth/user-not-found':
//         case 'auth/wrong-password':
//           setError('البريد الإلكتروني أو كلمة المرور غير صحيحة');
//           break;
//         default:
//           setError('فشل تسجيل الدخول. يرجى المحاولة مرة أخرى');
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="login-container">
//       <div className="login-card">
//       <div className="login-header">
//           <img src={logoImg} alt="شعار" className="login-logo" />
//           <h1 className="login-title">كوبرا<span>بوينتس</span></h1>
//         </div>
        
//         <h2 className="login-subtitle">تسجيل دخول المسؤول</h2>
        
//         {error && (
//           <div className="error-message">
//             <span>{error}</span>
//           </div>
//         )}
        
//         <form className="login-form" onSubmit={handleSubmit}>
//           <div className="form-group">
//             <label htmlFor="email">البريد الإلكتروني</label>
//             <input 
//               type="email" 
//               id="email" 
//               value={email}
//               onChange={(e) => setEmail(e.target.value)}
//               placeholder="أدخل بريدك الإلكتروني"
//               required
//             />
//           </div>
          
//           <div className="form-group">
//             <label htmlFor="password">كلمة المرور</label>
//             <input 
//               type="password" 
//               id="password" 
//               value={password}
//               onChange={(e) => setPassword(e.target.value)}
//               placeholder="أدخل كلمة المرور"
//               required
//             />
//           </div>
          
//           <button 
//             type="submit" 
//             className="login-button"
//             disabled={loading}
//           >
//             {loading ? 'جاري تسجيل الدخول...' : 'تسجيل الدخول'}
//           </button>
//         </form>
        
//         <div className="login-footer">
//           <p>الوصول مقيد للموظفين المصرح لهم فقط</p>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import '../styles/Login.css';
import logoImg from '../logo.png'; // Make sure path is correct

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const auth = getAuth();
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      
      // Special handling for admin@cobra.com
      if (email.toLowerCase() === 'admin@cobra.com') {
        // Set isAdmin flag in localStorage
        localStorage.setItem('isAdmin', 'true');
        navigate('/dashboard');
      } else {
        // Regular user
        localStorage.setItem('isAdmin', 'false');
        navigate('/customers'); // Regular users go to customers page
      }
    } catch (err) {
      console.error('Login error:', err.message);
      
      // Handle different error codes with user-friendly messages
      switch (err.code) {
        case 'auth/invalid-email':
          setError('صيغة البريد الإلكتروني غير صالحة');
          break;
        case 'auth/user-disabled':
          setError('تم تعطيل هذا الحساب');
          break;
        case 'auth/user-not-found':
        case 'auth/wrong-password':
        case 'auth/invalid-credential':
          setError('البريد الإلكتروني أو كلمة المرور غير صحيحة');
          break;
        default:
          setError('فشل تسجيل الدخول. يرجى المحاولة مرة أخرى');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-header">
          <img src={logoImg} alt="شعار" className="login-logo" />
        </div>
        
        <h2 className="login-subtitle">تسجيل دخول المسؤول</h2>
        
        {error && (
          <div className="error-message">
            <span>{error}</span>
          </div>
        )}
        
        <form className="login-form" onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">البريد الإلكتروني</label>
            <input 
              type="email" 
              id="email" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="أدخل بريدك الإلكتروني"
              required
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">كلمة المرور</label>
            <input 
              type="password" 
              id="password" 
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="أدخل كلمة المرور"
              required
            />
          </div>
          
          <button 
            type="submit" 
            className="login-button"
            disabled={loading}
          >
            {loading ? 'جاري تسجيل الدخول...' : 'تسجيل الدخول'}
          </button>
        </form>
        
        <div className="login-footer">
          <p>الوصول مقيد للموظفين المصرح لهم فقط</p>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;